"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schoolGroupKey = exports.parentKey = exports.invalidStudentKey = exports.invalidTeacherKey = exports.classKey = exports.studentKey = exports.teacherKey = exports.schoolKey = exports.UserError = exports.SchoolEntityTypes = void 0;
var SchoolEntityTypes;
(function (SchoolEntityTypes) {
    SchoolEntityTypes["School"] = "school";
    SchoolEntityTypes["Class"] = "class";
    SchoolEntityTypes["Student"] = "student";
    SchoolEntityTypes["Teacher"] = "teacher";
    SchoolEntityTypes["InvalidStudent"] = "invalid-student";
    SchoolEntityTypes["InvalidTeacher"] = "invalid-teacher";
    SchoolEntityTypes["Parent"] = "parent";
    // These 2 look weird since we can't use "school" as a prefix
    // Reason: the store uses begins_with on these values to query entities and the 'school'
    //         prefix exists above
    SchoolEntityTypes["SchoolGroup"] = "group-school";
    SchoolEntityTypes["SchoolGroupLink"] = "link-group-school";
})(SchoolEntityTypes = exports.SchoolEntityTypes || (exports.SchoolEntityTypes = {}));
var UserError;
(function (UserError) {
    UserError["NoEmail"] = "NoEmail";
    UserError["InvalidEmail"] = "InvalidEmail";
    UserError["EmailNotMatchingSchoolPattern"] = "EmailNotMatchingSchoolPattern";
    UserError["DuplicateUser"] = "DuplicateUser";
    UserError["DuplicateStudentTeacher"] = "DuplicateStudentTeacher";
    UserError["NonTeachingStaff"] = "NonTeachingStaff";
    UserError["SyncedToOtherSchool"] = "SyncedToOtherSchool";
})(UserError = exports.UserError || (exports.UserError = {}));
const entityKey = (entityType) => (entityId) => `${entityType}-${entityId}`;
exports.schoolKey = entityKey(SchoolEntityTypes.School);
exports.teacherKey = entityKey(SchoolEntityTypes.Teacher);
exports.studentKey = entityKey(SchoolEntityTypes.Student);
exports.classKey = entityKey(SchoolEntityTypes.Class);
exports.invalidTeacherKey = entityKey(SchoolEntityTypes.InvalidTeacher);
exports.invalidStudentKey = entityKey(SchoolEntityTypes.InvalidStudent);
exports.parentKey = entityKey(SchoolEntityTypes.Parent);
exports.schoolGroupKey = entityKey(SchoolEntityTypes.SchoolGroup);
//# sourceMappingURL=common.js.map